import { RenderTextWithContainerPattern, ReportSection } from "../constant";
import AssessmentBlock from "../_shared/AssessmentBlock";
import CptCodesBlock from "../_shared/CptCodesBlock";
import ScreeningAssessmentBlock from "../_shared/ScreeningAssessmentBlock";

interface SoapNoteTemplateProps {
  data: any;
}

/**
 * SoapNoteTemplate — Primary Care SOAP Note / SIMPLE_SOAP_NOTE / default
 *
 * Sequence strictly follows SOAP structure:
 *   Subjective → Objective → Assessment → Plan → Follow-Up
 */
const SoapNoteTemplate = ({ data }: SoapNoteTemplateProps) => {
  return (
    <>
      <ReportSection label="Subjective">
        <RenderTextWithContainerPattern
          label="Subjective"
          val={data?.subjectiveFreeNote}
        />
      </ReportSection>

      <ReportSection label="Objective">
        <RenderTextWithContainerPattern
          label="Objective"
          val={data?.objectiveFreeNote}
        />
        <ScreeningAssessmentBlock data={data} />
      </ReportSection>

      <ReportSection label="Assessment">
        <AssessmentBlock data={data} />
      </ReportSection>

      <ReportSection label="Plan">
        <RenderTextWithContainerPattern label="Plan" val={data?.planFreeNote} />
        <CptCodesBlock data={data} />
        <RenderTextWithContainerPattern
          label="Care Plan"
          val={data?.carePlan}
        />
      </ReportSection>

      <ReportSection label="Follow-Up">
        <RenderTextWithContainerPattern
          label="Follow Up"
          val={data?.followUp}
        />
        <RenderTextWithContainerPattern
          label="Instructions"
          val={data?.instruction}
        />
      </ReportSection>
    </>
  );
};

export default SoapNoteTemplate;
